import React from 'react'
import { Link as GLink } from 'gatsby'
import { Text, Link } from 'theme-ui'
import rv from '@components/utils/buildResponsiveVariant'
import { getSelectedArticleAuthors } from '../../../../themes/gatsby-theme-flexiblog-personal/src/helpers/nr-authors.helper'

const styles = {
  author: {
    pr: 2
  }
}

const CardFooterAuthorName = ({ variant, omitAuthor, title }) => {
  let authors = getSelectedArticleAuthors(title)
  let str = ''
  authors.forEach((el, i) => {
    if (i === authors.length - 1) {
      str += el.name
    } else {
      str += el.name + ' & '
    }
  })

  return !omitAuthor ? (
    <Text sx={{ ...styles.author, variant: rv(variant, 'author') }}>
      {
        authors.map((author, index) => {
          return <> <Link variant='mute' as={GLink} to={`/author/${author.slug}/`}>
            <strong>{author.name}</strong>
          </Link>
            <strong>{(authors.length - 1) !== index ? " & " : ""}</strong> </>
        })
      }
    </Text>
  ) : null
}
export default CardFooterAuthorName
